import Project from 'src/store/models/Project';
import moment from 'moment';
import User from 'src/store/models/User';
import Group from 'src/store/models/Group';
import PhaseCategory from 'src/store/models/PhaseCategory';
import ExpenseCategory from 'src/store/models/ExpenseCategory';
import Client from 'src/store/models/Client';
import TagList from 'src/store/models/TagList';
import Integration from 'src/store/models/Integration';
import SubscriptionType from 'src/store/models/SubscriptionType';
import ApprovalRequest from 'src/store/models/ApprovalRequest';
import Feature from 'src/store/models/Feature';
export var abridgedDataUtils = {
  methods: {
    // abridged data
    getAbridgedProjects: function getAbridgedProjects() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var lastPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var syncing = this.$store.state.entities.projects.pending;

      if (!syncing || page > 0) {
        Project.commit(function (state) {
          state.pending = true;
        });
        page++;
        Project.api().get('/projects', {
          params: {
            account_id: this.me.account_id,
            abridged: 1,
            page: page,
            per_page: 2000
          }
        }).then(function (result) {
          lastPage = result.response.data.last_page;

          if (page < lastPage) {
            Project.commit(function (state) {
              state.lastSync = moment().unix();
            });

            _this.getAbridgedProjects(page, lastPage);
          } else {
            Project.commit(function (state) {
              state.pending = false;
              state.lastSync = moment().unix();
            });

            _this.$root.$emit('refresh-projects');

            _this.$root.$emit('projects-first-load');
          }
        }).catch(function () {});
      }
    },
    getAbridgedUsers: function getAbridgedUsers() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var lastPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var syncing = this.$store.state.entities.users.pending;

      if (!syncing || page > 0) {
        User.commit(function (state) {
          state.pending = true;
        });
        page++;
        User.api().get('/users', {
          params: {
            account_id: this.me.account_id,
            abridged: 1,
            page: page,
            per_page: 2000
          }
        }).then(function (result) {
          lastPage = result.response.data.last_page;

          if (page < lastPage) {
            User.commit(function (state) {
              state.lastSync = moment().unix();
            });

            _this2.getAbridgedUsers(page, lastPage);
          } else {
            User.commit(function (state) {
              state.pending = false;
              state.lastSync = moment().unix();
            });

            _this2.$root.$emit('refresh-users');
          }
        }).catch(function () {});
      }
    },
    getAbridgedGroups: function getAbridgedGroups() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var lastPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var syncing = this.$store.state.entities.groups.pending;

      if (!syncing || page > 0) {
        Group.commit(function (state) {
          state.pending = true;
        });
        page++;
        Group.api().get('/groups', {
          params: {
            account_id: this.me.account_id,
            abridged: 1,
            page: page,
            per_page: 2000
          }
        }).then(function (result) {
          lastPage = result.response.data.last_page;

          if (page < lastPage) {
            Group.commit(function (state) {
              state.lastSync = moment().unix();
            });

            _this3.getAbridgedGroups(page, lastPage);
          } else {
            Group.commit(function (state) {
              state.pending = false;
              state.lastSync = moment().unix();
            });

            _this3.$root.$emit('refresh-groups');
          }
        }).catch(function () {});
      }
    },
    getAbridgedCategories: function getAbridgedCategories() {
      var _this4 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var lastPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var syncing = this.$store.state.entities['task-categories'].pending;

      if (!syncing || page > 0) {
        PhaseCategory.commit(function (state) {
          state.pending = true;
        });
        page++;
        PhaseCategory.api().get('/phase-categories', {
          params: {
            account_id: this.me.account_id,
            abridged: 1,
            page: page,
            per_page: 2000
          }
        }).then(function (result) {
          lastPage = result.response.data.last_page;

          if (page < lastPage) {
            PhaseCategory.commit(function (state) {
              state.lastSync = moment().unix();
            });

            _this4.getAbridgedCategories(page, lastPage);
          } else {
            PhaseCategory.commit(function (state) {
              state.pending = false;
              state.lastSync = moment().unix();
            });

            _this4.$root.$emit('refresh-categories');
          }
        }).catch(function () {});
      }
    },
    getAbridgedExpenseCategories: function getAbridgedExpenseCategories() {
      var _this5 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var lastPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var syncing = this.$store.state.entities['expense-categories'].pending;

      if (!syncing || page > 0) {
        ExpenseCategory.commit(function (state) {
          state.pending = true;
        });
        page++;
        ExpenseCategory.api().get('/expense-categories', {
          params: {
            account_id: this.me.account_id,
            abridged: 1,
            page: page,
            per_page: 2000
          }
        }).then(function (result) {
          lastPage = result.response.data.last_page;

          if (page < lastPage) {
            ExpenseCategory.commit(function (state) {
              state.lastSync = moment().unix();
            });

            _this5.getAbridgedExpenseCategories(page, lastPage);
          } else {
            ExpenseCategory.commit(function (state) {
              state.pending = false;
              state.lastSync = moment().unix();
            });

            _this5.$root.$emit('refresh-expenses');
          }
        }).catch(function () {});
      }
    },
    getAbridgedClients: function getAbridgedClients() {
      var _this6 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var lastPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var syncing = this.$store.state.entities.clients.pending;

      if (!syncing || page > 0) {
        Client.commit(function (state) {
          state.pending = true;
        });
        page++;
        Client.api().get('/clients', {
          params: {
            account_id: this.me.account_id,
            abridged: 1,
            page: page,
            per_page: 2000
          }
        }).then(function (result) {
          lastPage = result.response.data.last_page;

          if (page < lastPage) {
            Client.commit(function (state) {
              state.lastSync = moment().unix();
            });

            _this6.getAbridgedClients(page, lastPage);
          } else {
            Client.commit(function (state) {
              state.pending = false;
              state.lastSync = moment().unix();
            });

            _this6.$root.$emit('refresh-clients');
          }
        }).catch(function () {});
      }
    },
    getAbridgedTags: function getAbridgedTags() {
      var _this7 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var lastPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var syncing = this.$store.state.entities['tag-lists'].pending;

      if (!syncing || page > 0) {
        TagList.commit(function (state) {
          state.pending = true;
        });
        page++;
        TagList.api().get('/tag-lists', {
          params: {
            account_id: this.me.account_id,
            abridged: 1,
            show_totals: 1,
            page: page,
            per_page: 2000
          }
        }).then(function (result) {
          lastPage = result.response.data.last_page;

          if (page < lastPage) {
            TagList.commit(function (state) {
              state.lastSync = moment().unix();
            });

            _this7.getAbridgedTags(page, lastPage);
          } else {
            TagList.commit(function (state) {
              state.pending = false;
              state.lastSync = moment().unix();
            });

            _this7.$root.$emit('refresh-tags');
          }
        }).catch(function () {});
      }
    },
    getAbridgedIntegrations: function getAbridgedIntegrations() {
      var _this8 = this;

      var syncing = this.$store.state.entities.integrations.pending;

      if (!syncing) {
        Integration.commit(function (state) {
          state.pending = true;
        });
        Integration.api().get('/integrations', {
          params: {
            abridged: 1
          }
        }).then(function (result) {
          Integration.commit(function (state) {
            state.pending = false;
            state.lastSync = moment().unix();

            _this8.$root.$emit('integrations-ready');
          });
        }).catch(function () {});
      }
    },
    getSubscriptionTypes: function getSubscriptionTypes() {
      SubscriptionType.api().get('/subscription-types', {
        params: {
          is_old: 0,
          load: ['features']
        }
      }).catch(function () {});
    },
    getFeatures: function getFeatures() {
      Feature.api().get('/features', {
        params: {
          load: ['subscription-types']
        }
      }).catch(function () {});
    },
    getAbridgedApprovalRequests: function getAbridgedApprovalRequests() {
      var syncing = this.$store.state.entities['approval-requests'].pending;

      if (!syncing) {
        ApprovalRequest.commit(function (state) {
          state.pending = true;
        });
        ApprovalRequest.api().fetch({
          params: {
            user_ids: [this.me.user_id],
            abridged: 1
          }
        });
      }
    }
  }
};